import { Component, EventEmitter, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { User } from "src/app/core/user/user";
import { UserService } from "src/app/core/user/user.service";
import { Coletor } from "../coletor/coletor";
import { Doador } from "../doador/doador";
import * as extenso from "extenso";

@Component({
  selector: "app-pdf-contrato-page",
  templateUrl: "./pdf-contrato-page.component.html",
  styleUrls: ["./pdf-contrato-page.component.css"],
})
export class PdfContratoPageComponent implements OnInit {
  doador: Doador;
  coletor: Coletor;
  coletaValida: boolean;
  emitter: EventEmitter<void> = new EventEmitter();
  dataNascimentoDoador: string;
  dataNascimentoResp1: string;
  dataNascimentoResp2: string;
  campoVazio: string = " ";
  user$: Observable<User>;
  nomeCPC: string;
  crp: string;
  numeroOrgaoRegulador: string;
  credenciadoNome: string;
  telefoneCelular: string;
  estadoOrgao: string;
  maiorDeIdade: boolean = false;
  nomeContrantante: string;
  semResponsavel2: boolean = false;
  linhaAssinatura: string = "_____________________________________________";
  dataHoraAtual: string;
  taxaContratoFormatada: string;
  taxaPorExtenso: string;

  constructor(private userService: UserService) {
    this.user$ = this.userService.getUser();
  }

  ngOnInit(): void {
    this.dataDeNascimento();
    this.idade();
    this.userSubscribe();
    this.numeroExtenso();
  }

  ngAfterViewInit(): void {
    console.log(this.doador);
    this.emitter.emit();
  }

  dataNascimentoFormatada(doadorColetor) {
    if (doadorColetor) {
      let dataNascimento = doadorColetor;
      let dataN = dataNascimento.split("/");
      let dataA = dataN[2];
      let dataM = dataN[1];
      let dataD = dataN[0];
      let dataNFormatada = `${dataD}/${dataM}/${dataA}`;
      return dataNFormatada;
    }
    return "";
  }

  // por algum motivo o back não retorna as infos com o mesmo padrão
  dataNascimentoFormatadaInvertida(doadorColetor) {
    if (doadorColetor) {
      let dataNascimento = doadorColetor;
      let dataN = dataNascimento.split("/");
      let dataA = dataN[0];
      let dataM = dataN[1];
      let dataD = dataN[2];
      let dataNFormatada = `${dataD}/${dataM}/${dataA}`;
      return dataNFormatada;
    }
    return "";
  }

  dataDeNascimento() {
    if (this.doador.dataNascimento) {
      this.dataNascimentoDoador = this.dataNascimentoFormatadaInvertida(
        this.doador.dataNascimento.replace(/-/g, "/")
      );
    }

    if (this.coletor.dataNascimentoResponsavel1) {
      this.dataNascimentoResp1 = this.dataNascimentoFormatada(
        this.coletor.dataNascimentoResponsavel1
      );
    }
    if (this.coletor.dataNascimentoResponsavel2) {
      this.dataNascimentoResp2 = this.dataNascimentoFormatada(
        this.coletor.dataNascimentoResponsavel2
      );
    }
  }

  idade() {
    if (!this.doador.dataNascimento) {
      return;
    }
    let dataNascimento = this.doador.dataNascimento;
    let dataN = dataNascimento.split("-");
    let dataA = dataN[0];
    let dataM = dataN[1];
    let dataD = dataN[2];
    let date = new Date();
    let dataNFormatada = `${dataM}/${dataD}/${dataA}`;

    let dataNascimentoFormatada = new Date(dataNFormatada);
    let idadeDoador = parseInt(
      this.calcularIdade(dataNascimentoFormatada, date) + ""
    );

    if (idadeDoador >= 18) {
      this.maiorDeIdade = true;
      this.nomeContrantante = "Nome do CONTRATANTE";
    } else {
      this.nomeContrantante = "Nome do CONTRATANTE 1";
      if (!this.coletor.nomeResponsavel2) {
        this.semResponsavel2 = true;
        this.nomeContrantante = "Nome do CONTRATANTE";
      }
    }
  }

  calcularIdade(nascimento, hoje) {
    var idade = hoje.getFullYear() - nascimento.getFullYear();
    if (
      new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) <
      new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())
    )
      idade--;
    return idade;
  }

  userSubscribe() {
    this.user$.subscribe((user) => (this.credenciadoNome = user.sub));

    this.user$.subscribe((user) => (this.crp = user.orgaoRegulador));

    this.user$.subscribe(
      (user) => (this.numeroOrgaoRegulador = user.numeroOrgaoRegulador)
    );

    this.user$.subscribe(
      (user) => (this.telefoneCelular = user.telefoneCelular)
    );

    this.user$.subscribe((user) => (this.estadoOrgao = user.estadoOrgao));
  }

  dataHoraFinalizacao(): string {
    if (!this.doador.dataHoraEditarCliente) return;
    let dataHoraFinalizacao = this.doador.dataHoraEditarCliente;
    let dataN = dataHoraFinalizacao.split("/");
    let dataN2 = dataN[2].split(" ");
    let dataA = dataN[0];
    let dataM = dataN[1];
    let dataD = dataN2[0];
    let dataNFormatada = `${dataA}/${dataM}/${dataD}`;
    let hora = dataN2[1];
    return dataNFormatada + " " + hora;
  }

  numeroExtenso() {
    if (!this.doador.taxaContrato) return;

    console.log(this.doador.taxaContrato);
    this.taxaContratoFormatada = (
      Math.round(parseFloat(this.doador.taxaContrato) * 100) / 100
    )
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    console.log(this.taxaContratoFormatada);
    let taxaSplit = this.taxaContratoFormatada.split(",");
    if (taxaSplit[1].length === 1) {
      taxaSplit.push("0");
      let reais = taxaSplit[0];
      let centavos = taxaSplit[1] + taxaSplit[2];
      this.taxaContratoFormatada = `${reais},${centavos}`;
    }
    this.taxaPorExtenso = extenso(this.taxaContratoFormatada, {
      number: { decimal: "informal" },
      mode: "currency",
    });
  }
}
